//接口域名地址
let baseURL, protocol = 'https://',
    hostName = '',
    appName = 'gzzc';
if (process.env.NODE_ENV === 'development') {
    hostName = 'testapi.bjsjsadr.com'
} else if (process.env.NODE_ENV === 'production') {
    if (process.env.VUE_APP_TYPE === "test") {
        hostName = 'testapi.bjsjsadr.com'
    } else if (process.env.VUE_APP_TYPE === "dev") {
        hostName = 'testapi.bjsjsadr.com'
    } else if (process.env.VUE_APP_TYPE === 'prod') {
        hostName = "meeting.courtcloud.cn";
    } else {
        hostName = 'testgzzcwww.courtcloud.cn'
    }
}
baseURL = protocol + hostName

export default {
    baseURL: baseURL,
    hostName: hostName,
    appName: appName
}
